const axios = require('axios');
import jQuery from "jquery"; window.$ = window.jQuery = jQuery;


(() => {
	"use strict";
	const d = document;
	const validateEmpty = (value) =>  value.replace(/\s/g, '') !== '';
	const validateEmail = (value) =>  /^([\w-\.äöüß]+@([\w-.äöüß]+\.)+[\w-]{2,4})?$/.test(value);

	const submitForm = (form) => {

		const formMessages = form.querySelector('.form-message-error'),
			submitButton = form.querySelector("button"),
			actionUrl = form.getAttribute('action'),
			action = form.getAttribute('data-action'),
			data = new FormData(form),
			firstInvalidItem = form.querySelector('.invalid'),
			formRows = form.querySelectorAll('.form-row'),
			hideOnSuccess = form.querySelectorAll('.form-row, .hide-on-success'),
			messageSuccess = form.querySelector('.form-message-success').textContent;
		;

		if(firstInvalidItem !== null){
			const firstInvalidItemToTop = firstInvalidItem.getBoundingClientRect().top + document.documentElement.scrollTop - 50;
			formMessages.innerText = 'Bitte überprüfen Sie die rot markierten Felder.';
			return false;
		}

		data.append('action', action );
		submitButton.classList.add('loading');

		console.log(messageSuccess);

		axios( {
			method: 'post',
			url: actionUrl,
			data: data,
			headers: {'Content-Type': 'multipart/form-data' }
		})
			.then( ({ data }) => {

				if(data.success) {
					document.querySelector('form.validate button').remove();

					formMessages.innerText = "Vielen Dank! Ihre Anfrage wird schnellstmöglich bearbeitet.";

					if(messageSuccess){
						formMessages.innerText = messageSuccess;
					}

					formMessages.classList.add("success");
					submitButton.classList.remove('loading');
					formRows.forEach((elem) => {
						elem.style.display = 'none';
					})
					hideOnSuccess.forEach((elem) => {
						elem.style.display = 'none';
					})

					if(action === 'prm_lead'){
						ga('send', 'event', 'Form', 'submit', 'Formular abgeschickt: Unverbindliche Beratung');
					}
				} else {
					formMessages.innerText = "Ein Fehler ist aufgetreten. Bitte kontaktieren Sie uns unter support@prm-parken.de.";
					submitButton.classList.remove('loading');
				}
			})
			.catch((error) => {
				console.log(error);
			})

	};

	const checkValue = (element) => {
		const val = element.value;

		if(!validateEmpty(val)
			|| element.classList.contains('email') && !validateEmail(val)
			|| element.type === 'checkbox' && !element.checked)
		{
			element.classList.add('invalid');
		} else {
			element.classList.remove('invalid');
		}
	};

	const validateAndSubmit = (e) => {
		const target = e.target;
		e.preventDefault();

		target.querySelectorAll('.required').forEach(element => checkValue(element));
		submitForm(target);
	};

	d.querySelectorAll('form.validate').forEach(form => {
		form.addEventListener('submit', validateAndSubmit);

		form.querySelectorAll('input, textarea').forEach(elem =>{
			elem.addEventListener('input', () => {
				checkValue(elem);
			});
		});

	});


})();

